<template>
  <v-menu>
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        rounded
        outlined
        class="mx-2"
        v-text="text"
      />
    </template>
    <v-list color="secondary">
      <v-list-item-group
        v-model="value"
        mandatory
      >
        <v-list-item
          v-for="dishOrder in dishOrders"
          :key="dishOrder.id"
          :value="dishOrder.order"
        >
          <v-list-item-content>
            <v-list-item-title v-text="dishOrder.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    computed: {
      value: {
        get () {
          return this.$store.state.orders.dishOrder
        },
        set (v) {
          this.$store.commit('orders/dishOrder', v)
        },
      },
      dishOrders () {
        return this.$store.getters['catalog/activeDishOrders']
      },
      text () {
        return this.dishOrders.find(o => o.order == this.value)?.name.substr(0, 2) ?? '?'
      },
    },
  }
</script>
